"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeDefs = void 0;
exports.TypeDefs = {
    MenuManager: Symbol.for("MenuManager"),
    NavBarManager: Symbol.for("NavBarManager"),
    RoutesManager: Symbol.for("RoutesManager"),
    WidgetsManager: Symbol.for("WidgetsManager"),
    CommandManager: Symbol.for("CommandManager"),
    I18nManager: Symbol.for("I18nManager"),
    UserSettingsStorage: Symbol.for("UserSettingsStorage"),
    ApplicationGuard: Symbol.for("ApplicationGuard"),
    ThemeVars: Symbol.for("ThemeVars"),
    NotificationsService: Symbol.for("NotificationsService"),
    RequestModifier: Symbol.for("RequestModifier"),
    JourneyComponentsManager: Symbol.for("JourneyComponentsManager"),
    CacheService: Symbol.for("CacheService"),
    LoggerService: Symbol.for("LoggerService")
};
//# sourceMappingURL=TypeDefs.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/TypeDefs.js
// module id = 212
// module chunks = 0